<div class="sidenav-user-toolbar">
  <h4>
    Theme Customizer
  </h4>
  <button class="btn-back" mat-icon-button [matTooltip]="'back'" (click)="closeSidenav()">
    <i class="material-icons">
      close
    </i>
  </button>
</div>
<div class="sidenav-user-container">
  <div class="profile_detail mt-3">
    <ul class="list-items">
      <li>
        <span class="title">
          Color Scheme
        </span>
        <div class="desc">
          <div class="colorscheme-cardradio">
            <div class="row">
              <div class="col-5">
                <div class="form-check card-radio">
                  <input class="form-check-input" type="radio" name="data-layout-mode" [(ngModel)]="themeColor"
                    (change)="setThemeColor()" id="layout-mode-light" value="light">
                  <label class="form-check-label p-0 avatar-md w-100 shadow-sm" for="layout-mode-light">
                    <i class="material-icons icon_selected">
                      done
                    </i>
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-soft-primary rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-soft-primary"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                          <span class="bg-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class=" text-center mt-2">Light</h5>
              </div>

              <div class="col-5">
                <div class="form-check card-radio dark">
                  <input class="form-check-input" type="radio" name="data-layout-mode" [(ngModel)]="themeColor"
                    (change)="setThemeColor()" id="layout-mode-dark" value="dark">
                  <label class="form-check-label p-0 avatar-md w-100 shadow-sm bg-dark" for="layout-mode-dark">
                    <i class="material-icons icon_selected">
                      done
                    </i>
                    <span class="d-flex gap-1 h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-soft-light d-flex h-100 flex-column gap-1 p-1">
                          <span class="d-block p-1 px-2 bg-soft-light rounded mb-2"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-soft-light"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-soft-light"></span>
                          <span class="d-block p-1 px-2 pb-0 bg-soft-light"></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-soft-light d-block p-1"></span>
                          <span class="bg-soft-light d-block p-1 mt-auto"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="fs-13 text-center mt-2">Dark</h5>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>